var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app-container admin-pc-home"},[_c('div',{staticClass:"admin-pc-home__body"},[_c('p',{staticClass:"admin-pc-home__title"},[_vm._v("欢迎进入逻拓后管系统")]),(_vm.displayName)?_c('p',{staticClass:"admin-pc-home__user"},[_vm._v(_vm._s(_vm.displayName)+"，您好")]):_vm._e()])])
}
var staticRenderFns = []

export { render, staticRenderFns }